import * as _ from 'lodash';
import { formatNumber } from '@angular/common';

function get_log() {
  if (location.hostname === 'localhost') {
    return console.log;
  }
  else {
    return function() {};
  }
}
export const llog = get_log();

export function format_number(val: any) {
  if (!val && val !== 0) return null;
  else if (isNaN(val)) return val;
  else return _.round(val, 2);
}

export function format_number_to_string(val: any, format: string = '1.2-2') {
  if (!val && val !== 0) return null;
  else if (isNaN(val)) return val;
  else return formatNumber(val, 'en-US', format);
}

export function format_number_to_abbrv(val: any) {
  if (!val && val !== 0) return null;
  else if (isNaN(val)) return val;

  const formatter = new Intl.NumberFormat('en', {
    notation: 'compact',
    compactDisplay: 'short',
    maximumSignificantDigits: 3
  });
  
  // Format the number and return the result
  return formatter.format(val);
}

export function format_customer(customer: any) {
  let formattedCustomer: any = null;

  switch (customer) {
    case 'mta':
      formattedCustomer = 'MTA';
      break;
    case 'option-pit':
      formattedCustomer = 'Option Pit';
      break;
    case 'theo-trade':
      formattedCustomer = 'TheoTrade';
      break;
    case 'strat-alerts':
      formattedCustomer = 'Strat Alerts';
      break;
    case 'alpha-shark':
      formattedCustomer = 'AlphaShark';
      break;
    case 'delphi-sig':
      formattedCustomer = 'Delphi Signal';
      break;
    case 'simpler-trading':
      formattedCustomer = 'Simpler Trading';
      break;
    case 'f2':
      formattedCustomer = 'F2';
      break;
    case 'mil-pub':
      formattedCustomer = 'Millionaire Publishing';
      break;
    case 'hima-reddy':
      formattedCustomer = 'Hima Reddy';
      break;
    default:
      break;
  }

  return formattedCustomer;
}

export function format_date_string(date_string: any) {
  const date = new Date(date_string);

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${month}/${day}/${year} ${hours}:${minutes}`;
}